module.exports = __webpack_public_path__ + "img/reading_bg_pattern.4a89e4c0.svg";